import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import propTypes from 'prop-types';
import classNames from 'classnames';
import close from '@images/icons/close.svg';
import doneIcon from '@images/icons/done.svg';

import styles from './Modal.module.scss';

// TODO: типизировать
class Modal extends Component {
  componentDidUpdate() {
    const { show } = this.props;
    /* eslint-disable no-undef */
    if (show) {
      document.body.style.overflowY = 'hidden';
    } else {
      document.body.style.overflowY = 'scroll';
    }
  }

  componentWillUnmount() {
    if (document.body.style.overflowY === 'hidden') {
      document.body.style.overflowY = 'scroll';
    }
    /* eslint-enable no-undef */
  }

  handleClose = () => {
    const { onClose } = this.props;
    onClose();
  };

  handleConfirm = () => {
    const { onConfirm, confirmValue } = this.props;
    if (!confirmValue) return null;
    onConfirm();
    return null;
  };

  render() {
    const { children, show, header, confirmValue, zoom, currentProductId } = this.props;
    if (typeof document !== 'undefined') {
      return ReactDOM.createPortal(
        <div className={classNames({ [styles.modal]: true, [styles.open]: show })}>
          <div role="dialog" className={styles.overlay} onClick={this.handleClose} />
          <div className={classNames({ [styles.dialog]: true, [styles.zoomDialog]: zoom })}>
            {!zoom && (
              <div className={styles.modalHeader}>
                <button type="button" className={styles.close} onClick={this.handleClose}>
                  <img className={styles.closeImg} alt="close" src={close} />
                </button>
                <div className={styles.header}>{header && header}</div>
                <button
                  type="button"
                  className={classNames({ [styles.done]: true, [styles.opacity]: !confirmValue })}
                  onClick={currentProductId ? this.handleConfirm : null}
                >
                  <img className={styles.doneImg} alt="close" src={doneIcon} />
                  <span>Готово</span>
                </button>
              </div>
            )}
            <div className={styles.modalContent} aria-modal="true" tabIndex="-1" role="dialog">
              {show ? children : null}
            </div>
          </div>
        </div>,
        document.body
      );
    }
    return null;
  }
}

// eslint-disable-next-line react/static-property-placement
Modal.propTypes = {
  children: propTypes.node.isRequired,
  onClose: propTypes.func.isRequired,
  show: propTypes.bool,
  header: propTypes.string,
  confirmValue: propTypes.bool,
  onConfirm: propTypes.func,
  zoom: propTypes.bool,
};

// eslint-disable-next-line react/static-property-placement
Modal.defaultProps = {
  show: false,
  zoom: false,
  header: undefined,
  confirmValue: false,
  onConfirm: () => {},
};

export default Modal;
